<template>
    <div>
        <h2 class="clickable" :class="{ 'collapsed-heading': !expanded }" @click="expanded = !expanded">
            Warranty
            <v-icon v-if="expanded">arrow_drop_up</v-icon>
            <v-icon v-else>arrow_drop_down</v-icon>
        </h2>
        <v-expand-transition>
            <v-card v-show="expanded">
                <unit-warranty-fields :unit="unit"></unit-warranty-fields>
            </v-card>
        </v-expand-transition>
    </div>
</template>

<script>
import moment from 'moment';
import UnitWarrantyFields from '@/components/Units/Details/UnitWarrantyFields.vue';

export default {
    props: {
        unit: {
            required: true
        }
    },
    components: { UnitWarrantyFields },
    data: () => {
        return {
            expanded: false
        };
    }
};
</script>
